{
    "RangeCombo_Search_Placeholder": "Procurar...",
    "NAME": "RangeComboLanguage",
    "Validation_Generic_Error_Message": "Há um ou mais erros detectados no momento.",
    "Validation_Generic_Error_Max_Entries": "Você atingiu\/ultrapassou o número máximo de entradas."
}